import React, {useContext, useMemo} from 'react';
import {AuthContext} from "../../../shared/contexts/authContext";
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {useItemKrTextData} from "../../probability/useItemData";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {getGachaLogColumns} from "../../logs/columns/gachaLogColumns";
import {Sorter} from "../../../shared/components/Sorter";

const PlayerGachaLog = () => {
    const { currentUser } = useContext(AuthContext);
    const { playerData } = useContext(PlayerContext);

    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        pid: playerData.pid,
        logType: 'RQGachaLog',
        isUnix: true
    };

    const dateColumn = {
        title: '날짜',
        dataIndex: 'created',
        render: (time) => dayjs.unix(time).format('YYYY-MM-DD HH:mm:ss'),
        sorter: (a, b) => Sorter.DATE(a.time, b.time),
    };

    const columns = [
        ...getGachaLogColumns(krItemTextData, currentUser),
        dateColumn
    ];


    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;
    return (
        <div>
            <LogTemplate
                columns={columns}
                defaultSearchParams={defaultSearchParams}
                routerUrl={'/logs/operation'}
                logName={'GachaLog'}
                log={'operation'}
            />
        </div>
    );
};

export default PlayerGachaLog;